import { CreditNoteConstant } from "presentation/constant/CreditNote/CreditNoteConstant";
import { hdrStateDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { useCreditNoteHeaderVM } from "presentation/hook/CreditNote/useCreditNoteHeaderVM";
import { useCreditNoteHeaderMaintenanceTracked } from "presentation/store/CreditNote/CreditNoteHeaderMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { FieldType, HPHInputMask, IFieldValue } from "veronica-ui-component/dist/component/core";
const CreditNoteHeaderSearchForm = () => {

    const [creditNoteHeaderState] = useCreditNoteHeaderMaintenanceTracked();
    const creditNoteHeaderVM = useCreditNoteHeaderVM();
    const creditNoteHeaderSearchCriteria = creditNoteHeaderState.searchCriteria;
    const CREDIT_NOTE_CONSTANT = CreditNoteConstant.Search;

    const memoHdrState = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={creditNoteHeaderSearchCriteria?.states?.join(',')}
                fieldValue={creditNoteHeaderSearchCriteria?.states}
                fieldLabel={CreditNoteConstant.Header.HDR_STATTE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'states'}
                maxLength={60}
                isMultipleDropDown={true}
                options={hdrStateDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [creditNoteHeaderSearchCriteria.states, creditNoteHeaderVM])

    const memoBillToCompany = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={creditNoteHeaderSearchCriteria?.billToCompanies?.join(',')}
                fieldValue={creditNoteHeaderSearchCriteria?.billToCompanies}
                fieldLabel={CreditNoteConstant.Header.BILL_TO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompanies'}
                maxLength={60}
                isMultipleDropDown={true}
                options={creditNoteHeaderState.dynamicOptions.billToCompDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [creditNoteHeaderSearchCriteria.billToCompanies, creditNoteHeaderState.dynamicOptions.billToCompDropdownOptions, creditNoteHeaderVM])

    const memoCoVslVoy = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "190px", maxWidth: "410px", width: "100%" }}>
            <HPHInputMask
                width='100%'
                label={CreditNoteConstant.Search.CO_VSL_VOY}
                value={{
                    co: creditNoteHeaderSearchCriteria.co ?? '',
                    vsl: creditNoteHeaderSearchCriteria.vsl ?? '',
                    voy: creditNoteHeaderSearchCriteria.voy ?? ''
                }}
                fieldConfiguration={{
                    co: { maxLength: 4, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    vsl: { maxLength: 6, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    voy: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                }}
                onDataChange={(e: any) => creditNoteHeaderVM.onSearchCoVslVoyChange(e, {
                    co: 'co',
                    vsl: 'vsl',
                    voy: 'voy'
                })} />
        </div>
        , [creditNoteHeaderSearchCriteria.co, creditNoteHeaderSearchCriteria.vsl, creditNoteHeaderSearchCriteria.voy, creditNoteHeaderVM])

    const memoReqNoFrom = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={creditNoteHeaderSearchCriteria.reqNoFrom || ''}
                fieldValue={creditNoteHeaderSearchCriteria.reqNoFrom}
                fieldLabel={CREDIT_NOTE_CONSTANT.REQ_NO_FROM}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'reqNoFrom'}
                maxLength={10}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.REQ_NO_FROM, creditNoteHeaderSearchCriteria.reqNoFrom, creditNoteHeaderVM])

    const memoReqNoTo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={creditNoteHeaderSearchCriteria.reqNoTo || ''}
                fieldValue={creditNoteHeaderSearchCriteria.reqNoTo}
                fieldLabel={CREDIT_NOTE_CONSTANT.REQ_NO_TO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'reqNoTo'}
                maxLength={10}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.REQ_NO_TO, creditNoteHeaderSearchCriteria.reqNoTo, creditNoteHeaderVM])

    const memoCreditNoteNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={creditNoteHeaderSearchCriteria.creditNoteNo || ''}
                fieldValue={creditNoteHeaderSearchCriteria.creditNoteNo}
                fieldLabel={CreditNoteConstant.Header.CREDIT_NOTE_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'creditNoteNo'}
                maxLength={12}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [creditNoteHeaderSearchCriteria.creditNoteNo, creditNoteHeaderVM])

    const memoOriginalInvoiceNo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={creditNoteHeaderSearchCriteria.originalInvoiceNo || ''}
                fieldValue={creditNoteHeaderSearchCriteria.originalInvoiceNo}
                fieldLabel={CreditNoteConstant.Header.ORIGINAL_INVOICE_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'originalInvoiceNo'}
                maxLength={12}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [creditNoteHeaderSearchCriteria.originalInvoiceNo, creditNoteHeaderVM])

    const memoCreditChargeNoFrom = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={creditNoteHeaderSearchCriteria.creditChargeNoFrom || ''}
                fieldValue={creditNoteHeaderSearchCriteria.creditChargeNoFrom}
                fieldLabel={CREDIT_NOTE_CONSTANT.CREDIT_CHARGE_NO_FROM}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'creditChargeNoFrom'}
                maxLength={12}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.CREDIT_CHARGE_NO_FROM, creditNoteHeaderSearchCriteria.creditChargeNoFrom, creditNoteHeaderVM])

    const memoCreditChargeNoTo = useMemo(() =>
        <div className='flex-row-item' style={{ minWidth: "190px", maxWidth: "190px", width: "47.5%" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={creditNoteHeaderSearchCriteria.creditChargeNoTo || ''}
                fieldValue={creditNoteHeaderSearchCriteria.creditChargeNoTo}
                fieldLabel={CREDIT_NOTE_CONSTANT.CREDIT_CHARGE_NO_TO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'creditChargeNoTo'}
                maxLength={12}
                isTextFieldCapitalize={true}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteHeaderVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.CREDIT_CHARGE_NO_TO, creditNoteHeaderSearchCriteria.creditChargeNoTo, creditNoteHeaderVM])

    const memoCreatedDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "190px", maxWidth: "410px", width: "100%" }}>
            <DateRangePickerComponent
                label={CreditNoteConstant.Search.CREATED_DATE_RANGE}
                width='100%'
                fieldNames={{ startField: "createdDateFrom", endField: "createdDateTo" }}
                dateRange={{ startDate: creditNoteHeaderSearchCriteria.createdDateFrom, endDate: creditNoteHeaderSearchCriteria.createdDateTo }}
                onDatesChange={creditNoteHeaderVM.onDateRangeChange}
            />
        </div>
        , [creditNoteHeaderSearchCriteria.createdDateFrom, creditNoteHeaderSearchCriteria.createdDateTo, creditNoteHeaderVM.onDateRangeChange])



    return <>

        <CriteriaItemContainer>
            {creditNoteHeaderState.enabledSearchCriteria.coVslVoy ? memoCoVslVoy : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {creditNoteHeaderState.enabledSearchCriteria.states ? memoHdrState : null}
            {creditNoteHeaderState.enabledSearchCriteria.billToCompanies ? memoBillToCompany : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {creditNoteHeaderState.enabledSearchCriteria.reqNoFrom ? memoReqNoFrom : null}
            {creditNoteHeaderState.enabledSearchCriteria.reqNoTo ? memoReqNoTo : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {creditNoteHeaderState.enabledSearchCriteria.creditNoteNo ? memoCreditNoteNo : null}
            {creditNoteHeaderState.enabledSearchCriteria.originalInvoiceNo ? memoOriginalInvoiceNo : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {creditNoteHeaderState.enabledSearchCriteria.creditChargeNoFrom ? memoCreditChargeNoFrom : null}
            {creditNoteHeaderState.enabledSearchCriteria.creditChargeNoTo ? memoCreditChargeNoTo : null}
        </CriteriaItemContainer>
        <CriteriaItemContainer>
            {creditNoteHeaderState.enabledSearchCriteria.createdDate ? memoCreatedDateFromTo : null}
        </CriteriaItemContainer>

    </>;
}
export default memo(CreditNoteHeaderSearchForm);